export function cacheRevalidateDuration() {
  const revalidateString = process.env.REVALIDATE_TIME || '600';
  const revalidateNumber = parseInt(revalidateString, 10);
  return revalidateNumber;
}